import { QuestionType } from 'services/campaign/types';
import { QuestionType as QuestionTypeGenerated } from 'generated-graphql/types';

export const convertToGeneratedQuestionType = (
  questionType: QuestionType | null | undefined
): QuestionTypeGenerated | null => {
  switch (questionType) {
    case QuestionType.TEXT:
      return QuestionTypeGenerated.Text;
    case QuestionType.DOCUMENT:
      return QuestionTypeGenerated.Document;
    default:
      return null;
  }
};
